import { siteInfo } from "@/mocks/homeData";

export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cinematic%20abstract%20background%20with%20warm%20orange%20and%20amber%20gradient%20flowing%20shapes%2C%20subtle%20film%20grain%20texture%2C%20luxurious%20dark%20theater%20atmosphere%2C%20soft%20glowing%20particles%2C%20elegant%20and%20mysterious%20mood%2C%208K%20quality&width=1920&height=800&seq=hero-bg-htsp-01&orientation=landscape"
          alt="黄桃视频背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-400 text-xs font-semibold tracking-wider uppercase mb-5 font-label">
              不缓冲 · 不卡顿 · 极速高清
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-50 leading-tight mb-5 font-heading">
              黄桃视频
              <br className="md:hidden" />
              <span className="text-primary-400"> 新一代高清<br className="hidden sm:block" />在线播放平台</span>
            </h1>

            <p className="text-sm md:text-base text-foreground-200/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {siteInfo.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {siteInfo.stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-300 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#media"
                onClick={(e) => handleScroll(e, "#media")}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer no-underline font-label"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#topics"
                onClick={(e) => handleScroll(e, "#topics")}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-foreground-200/30 text-foreground-100 font-medium text-sm hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer no-underline font-label"
              >
                <i className="ri-fire-line text-lg"></i>
                热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden relative">
                <img
                  src="https://readdy.ai/api/search-image?query=epic%20cinematic%20movie%20montage%20composition%20with%20dramatic%20lighting%2C%20multiple%20film%20scene%20fragments%20merged%20artistically%2C%20warm%20golden%20and%20deep%20shadow%20contrast%2C%20movie%20theater%20projector%20beam%20effect%2C%20luxurious%20dark%20tones&width=600&height=450&seq=hero-main-htsp-01&orientation=landscape"
                  alt="黄桃视频-高清流畅在线播放体验"
                  className="w-full h-full object-cover object-center rounded-2xl"
                />
                <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-foreground-200/10"></div>
              </div>

              <div className="absolute -bottom-4 -left-4 bg-background-900/90 backdrop-blur-sm rounded-xl px-4 py-3 border border-background-700/50">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></div>
                  <span className="text-xs text-foreground-200 font-medium whitespace-nowrap">
                    在线用户 128,653
                  </span>
                </div>
              </div>

              <div className="absolute -top-3 -right-3 bg-primary-500 rounded-lg px-3 py-2">
                <span className="text-xs text-background-50 font-bold whitespace-nowrap font-label">
                  4K HDR 上线
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}